export const weightRegular = 400
export const weightBold = 700

export const titleFont = 'Quincy'
export const titleFontFallback = [
  'ui-serif',
  'Georgia',
  'Cambria',
  '"Times New Roman"',
  'Times',
  'serif',
]

export const titleFontFull = [titleFont, ...titleFontFallback].join(', ')
